import { decamelizeKeys } from '../../lib';
import { getBackVersion } from '../../config';
import {
    RentalRentAdjustmentHistoryBaseSnapshot,
    RentalRentAdjustmentHistorySnapshot,
    RentalRentAdjustmentListSnapshot,
    RentalRentAdjustmentSnapshot,
} from '../../models/RentalPayment';
import api from '../api';

const updateRentAdjustmentParams = (
    contractId: string,
    params: RentalRentAdjustmentSnapshot
): Promise<RentalRentAdjustmentListSnapshot> =>
    api.request<RentalRentAdjustmentListSnapshot>({
        method: 'POST',
        data: decamelizeKeys(params),
        url: `${getBackVersion()}/agent/rental/contracts_rental/${contractId}/rent_adjustment`,
    });

const getRentAdjustmentHistory = (
    contractId: string
): Promise<RentalRentAdjustmentHistorySnapshot[]> =>
    api.request<RentalRentAdjustmentHistorySnapshot[]>({
        method: 'GET',
        url: `${getBackVersion()}/agent/rental/contracts_rental/${contractId}/rent_adjustment/history`,
    });

const createRentAdjustmentHistory = (
    contractId: string,
    item: RentalRentAdjustmentHistoryBaseSnapshot,
    billingsToOverride: string[]
): Promise<RentalRentAdjustmentHistorySnapshot> =>
    api.request<RentalRentAdjustmentHistorySnapshot>({
        method: 'POST',
        data: decamelizeKeys({
            ...item,
            billingsToOverride,
        }),
        url: `${getBackVersion()}/agent/rental/contracts_rental/${contractId}/rent_adjustment/history`,
    });

const updateRentAdjustmentHistory = (
    contractId: string,
    itemId: number,
    item: RentalRentAdjustmentHistoryBaseSnapshot,
    billingsToOverride: string[]
): Promise<RentalRentAdjustmentHistorySnapshot> =>
    api.request<RentalRentAdjustmentHistorySnapshot>({
        method: 'PUT',
        data: decamelizeKeys({
            ...item,
            billingsToOverride,
        }),
        url: `${getBackVersion()}/agent/rental/contracts_rental/${contractId}/rent_adjustment/history/${itemId}`,
    });

export {
    getRentAdjustmentHistory,
    createRentAdjustmentHistory,
    updateRentAdjustmentHistory,
    updateRentAdjustmentParams,
};
